let backButtonOverride: {
    fn: (() => boolean) | null;
} = { fn: null };

type RemoveOverrideCallback = () => void;

export function useHeaderBackbuttonOverride() {
    function overrideBackButtonAction(override: () => boolean): RemoveOverrideCallback {
        backButtonOverride.fn = override;
        return () => backButtonOverride.fn = null;
    }

    function maybeRunBackButtonOverride() {
        return backButtonOverride.fn != null && backButtonOverride.fn();
    }

    return {
        overrideBackButtonAction,
        maybeRunBackButtonOverride,
    };
}
